import { Fragment, useEffect, useRef, useState } from "react";
import { ContactAndSchedule } from "./ContactAndSchedule";
import ContactForm from "./ContactForm";
import { UnderConstruction } from "./UnderConstruction";
import { ASSETS_URL } from "../utils/constants";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { useParams } from "react-router-dom";
import { listOfUpdates } from "./Updates";

function UpdatePage({title, image}) {
    const containerRef = useRef(null)
    let { id } = useParams()
    const [updatePage, setUpdatePage] = useState();
    useEffect(() => {
      if(containerRef.current) {
        containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      }
    }, [containerRef])

    useEffect(() => {
      console.log('page: ', id)
      console.log(listOfUpdates)
      setUpdatePage(listOfUpdates.find((item) => item.id === parseInt(id)))
    },[id])

    useEffect(() => {
      console.log('update: ', updatePage)
    },[updatePage])
    
    return <>
      <div ref={containerRef} className="font-[Montserrat] w-[80%] min-h-[80vh]">
        {
          updatePage && <Fragment>
            <div className="relative">
              <img className="w-full h-[275px] rounded-t-lg object-cover opacity-50" src={updatePage.image} />
              <div className="text-white font-bold text-4xl absolute top-0 w-full h-full flex justify-center items-center">{updatePage.title}</div>
            </div>
            <div className="bg-white min-h-[80vh]">
              <div className="p-4 flex flex-col items-start">
                <div className="flex items-center italic"><CalendarDaysIcon className="h-4 w-4 mr-1"/>{updatePage.date}</div>
                <div className="mt-8 text-left">{updatePage.body}</div>
              </div>
              
            </div>
            
              
          </Fragment>
        }
        
      </div>
    </>
  }
  
  export default UpdatePage;